import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import MassNotification from '../../models/MassNotification';


export interface MassNotificationDetailState extends ApiState {
  massNotification?: MassNotification
}

export default requestReducer<MassNotificationDetailState>('MASS_NOTIFICATION_DETAIL')
